import { usePartyDateFormat } from 'customHooks/usePartyDateTimeFormat'
import moment from 'moment'

export const useDateString = () => {
  const partyDateFormat = usePartyDateFormat()

  return (date: Date) => moment(date).format(partyDateFormat)
}
